<template>
  <div class="sellProducts">
    <div
      style="display:flex; gap: 20px; margin-bottom: 5px;"
    >
      <div class="search-toggle">

        <p>{{ $t('SearchBy') }}</p>
        <div>
          <p
            :class="{ active2: toggleSearch === 'ArticleNumber' }"
            @click="showArticleNumber(), toggleSearch = 'ArticleNumber'"
          >
            {{ $t('ArticleNumber') }}
          </p>
          <p
            :class="{ active2: toggleSearch === 'Code' }"
            @click="showCode(), toggleSearch = 'Code'"
          >
            {{ $t('Code') }}
          </p>
        </div>
      </div>
      <div v-if="toggleSearch === 'ArticleNumber'">
        <div class="black">
          <b-icon-search
            v-if="searchArticle == ''"
            class="search1"
            style="position: absolute; left: 5px; top: 12px"
          />
          <b-icon-x-circle
            v-else-if="searchArticle != '' && !noSearch"
            class="search1"
            style="position: absolute; right: 20px; top: 12px; cursor: pointer"
            @click="searchArticle = ''"
          />
          <input
            v-model="searchArticle"
            type="text"
            autocomplete="off"
            name="search-box"
            :placeholder="$t('ArticleNumber')"
            :style="getArticleNameLike.length > 0 && noSearch ? 'border-radius: 8px 8px 0px 0px' : ''"
            @keyup="inputChanged"
            @keydown.down="onArrowDown"
            @keydown.up="onArrowUp"
          >
        </div>
        <div
          v-if="getArticleNameLike.length > 0 && noSearch"
          ref="scrollContainer"
          class="dropdrop"
          :style="getArticleNameLike.length > 7 ? 'height: 210px' : 'height: auto'"
        >
          <div
            v-for="(result, index) in getArticleNameLike"
            :key="index"
            ref="options"
            style="cursor: pointer"
            class="search-item"
            :class="{ 'is-active': index === arrowCounter }"
            @click="searchByOn(result); noSearch = false"
          >
            <p style="margin: 0">
              {{ result.articleNumber }}
            </p>
          </div>
        </div>
      </div>

      <!-- <div v-if="toggleSearch === 'Code'">
        <div class="black">
          <b-icon-search
            v-if="searchColor == ''"
            class="search1"
            style="position: absolute; left: 5px; top: 12px"
          />
          <b-icon-x-circle
            v-else-if="searchColor != '' && !noSearch1"
            class="search1"
            style="position: absolute; right: 20px; top: 12px; cursor: pointer"
            @click="searchColor = ''"
          />
          <input
            v-model="searchColor"
            :disabled="!materialId"
            type="text"
            autocomplete="off"
            name="search-box"
            :placeholder="$t('Code')"

            @keyup="inputChanged1"
            @keydown.down="onArrowDown1"
            @keydown.up="onArrowUp1"
          >
        </div>
        <div
          v-if="getMaterialColors.length > 0 && noSearch1"
          ref="scrollContainer"
          class="dropdrop"
          :style="getMaterialColors.length > 7 ? 'height: 210px' : 'height: auto'"
        >
          <div
            v-for="(result, index) in getMaterialColors"
            :key="index"
            ref="options"
            style="cursor: pointer"
            class="search-item"
            :class="{ 'is-active': index === arrowCounter }"
            @click="searchByCl(result); noSearch1 = false"
          >
            <p style="margin: 0">
              {{ result.colorName }}
            </p>
          </div>
        </div>
      </div> -->

      <button
        v-b-modal.sell-direct-stock
        class="button"
        @click="orderTypes"
      >
        <span
          v-if="ordersArticles ? ordersArticles.length > 0 : null"
          class="number"
        >{{ ordersArticles ? ordersArticles.length : null }}</span> {{ $t('AddOrder') }}
      </button>
    </div>

    <div>
      <table
        ref="exportable_table"
        class="team_table"
      >
        <thead>
          <tr>
            <th>
              {{ $t('ArticleNumber') }}
            </th>
            <th>
              {{ $t('Description') }}
            </th>
            <th>
              {{ $t('Amount') }}
            </th>
            <th>
              {{ $t('Price') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(products, index) in getProductStockSell"
            :key="index"
            class="hover-row"
            :style="classNameCh === products.articleNumber ? 'background-color: rgba(255, 39, 79, 0.1)' : ''"
            style="cursor:pointer"
            @click="matProps(products)"
          >
            <td>{{ $t(products.articleNumber) }}</td>
            <td>{{ $t(products.description) }}</td>
            <td>{{ $t(products.totalAmountInStock) }}</td>
            <td>{{ $t(products.price) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div>
      <b-pagination
        v-if="getSellableProductsTotalItems > 15"
        v-model="pageNumber"
        :total-rows="getSellableProductsTotalItems"
        :per-page="pageSize"
        first-number
        last-number
        align="fill"
        size="md"
        prev-class="prev-item"
        next-class="next-item"
        class="mt-1 mb-0"
      >
        <template #prev-text>
          <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
        </template>
        <template #next-text>
          <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
        </template>
      </b-pagination>
    </div>
    <SellOrderDirect
      :orders-articles="ordersArticles"
      @resetMaterials="resetMaterialss"
      @sellOrderDirect="sellDirect"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { client } from '@/domainConfig'
import SellOrderDirect from './modals/SellOrderDirect.vue'



export default {
  components: {
    SellOrderDirect,
  },
  props: ['ordersArticles'],
  data() {
    return {
      client: client.clientName,
      toggleSearch: 'ArticleNumber',
      articleNumber: null,
      pageNumber: 1,
      pageSize: 15,
      classNameCh: '',
      searchArticle: '',
      arrowCounter: 0,
      noSearch: false,
      orderNumberClient: null,
      addressOfClient: null,
      phoneOfClient: null,
      emailOfClient: null,
      nameOfClient: null,
    }
  },
  computed: {
    ...mapGetters(['getInvoiceByOrderNumber', 'getProductStockSell', 'getSellableProductsTotalItems', 'getArticleNumberNameLike', 'getArticleNameLike']),
  },
  watch: {
    pageNumber(newValue) {
      this.sellableProducts({ pageNumber: newValue, pageSize: this.pageSize })
    },
    pageSize(newValue) {
      this.sellableProducts({ pageNumber: this.pageNumber, pageSize: newValue })
    },
    searchArticle(value) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value == '') {
          this.removeLists()
          this.sellableProducts({
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
            articleNumber: null,
          });
        } else if (this.enterPressed) {
        // eslint-disable-next-line no-useless-return
          return;
        } else {
          this.productInStock_articleNumberLike(value);
          this.noSearch = true
        }
      }, 500);
    },
  },
  mounted() {
    this.sellableProducts({
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
    })
  },
  methods: {
    ...mapActions(['movingLocations', 'loadInvoiceByOrderNumber', 'accountDetails', 'usersByMultipleRoles', 'sellOrderInStock', 'loadOrderTypes', 'sellableProducts', 'totalStockGroupedByLocation', 'articleNumberNameLike', 'resetFilteredMVBySearch', 'productInStock_articleNumberLike']),
    sellDirect(value) {
      console.log('value', value)
      this.sellOrderInStock({
        object: value,
        successCallback: (response) => {
          this.downloadInvoice(response)
          this.sellableProducts({
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          })
        },
      });
    },
    downloadInvoice(value) {
      this.orderNumberClient = value
      this.loadInvoiceByOrderNumber({
        orderNumber: value,
      })
        .then(() => {
          const invoice = this.getInvoiceByOrderNumber;

          // Generate table content for probe dates
          const tableContent = this.generateInvoiceTableContent(invoice);
          const tableContent2 = this.generateInvoiceTableContent(invoice);
          let xharraIcon
          if (this.client == 'DrenushaXharra') {
            xharraIcon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAABqCAYAAAAvBQZbAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOHSURBVHgB7ZwxTBRBFIYfxo5AaaMNlZhYSy+2RuxshILERkNi5xlKI3YmRBsTCqjsNKEVe6xJpKOysTxDjfczN95xrMzs3lf+X3I5suy8nfnemzd3FMyc3X50FmZqroVBsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSAiLhLBICIuEsEgIi4SwSIjrVXfdvBGxtRFxZyFibrZqSByfRLzdifhxdPG64jy+H61RvN39iC/fL/9u703EvbsRve2Lv9e8Dz6Nxq+8jGq0zq/vUwyxuHLl7eWKVCAF1ERrJZ4/eCEtcHkpEBRPSVh9GJ3Q+N56/f16VpZYQbkiFVACc4X9HLz/Ob16jCb94knEg6U0fvnZ5TEfPqdXCT1bC8rx9K6qK82hibVBEn79HiR4/+r78rNaUK5IVaJ4vpW2ac0CJF3bTPfOz6aW0BXFmIx3q75S/vHtML2/Xh+tqYnlYbLEbkH4GGWRXTKfx73aTlXXNcZkPFWTaNNiMkpEHv+/batr7zbSz0re1k7UUt7ah0epzNXvlNVaKf3BfQeH6UXRnyIhmvfq5ugA+diLeLo5Wo+uaY1KkoRrB7agLPJ8S62nk3atZaPXNqrthTVM0yJEFiRh6uOan9YnxqtUwnP1VlIWqYz1hltUD5+v3FbqQ5KvfqPeOvkxqA2qEsXJW1oHXlc0D61F8TS/LCz3TR2oLSWKskhlTyiTbbZp/jynyTb1I1V37edJJS9LJHquYmhOOdHj1/fqD5hxyiL1QL208LZbNGe5aeFzs+0ODcXQKUq1CVWeWsXisF3kSu1IWaQmr16St1ZNVeo+iVcCtE2atqIqtulbShP94YlNnP4ZxdIu0+HTPx31yo5UbO39lLl82LQ9cJTlpp6ja9P0TQLNIZ/cHfriOHXftZUtLbrNd2RNTBU3KSsLnHLiFzg+GcWepJSs48LBVZnsGf9vNAb/GQ3CIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEsIiISwSwiIhLBLCIiEsEuIvb40EKb9BjHQAAAAASUVORK5CYII='
          } else if (this.client == 'WaloneFashion') {
            xharraIcon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFYAAABxCAYAAABP/1R5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANkSURBVHgB7Z0tbxVREIZPCa4BiUGhgAQNnmIbwKGKQxES/gRIPAmi9wcACbbFF81fwGCb6jaT9iTb7Tmze/aeZ9a8T3LN3q+9z8yZmf1I7s75w5fnSXTnVhIIEgshsRASCyGxEBILIbEQEgshsRASCyGxEBILIbEQEgshsRASCyGxEBILIbEQEgshsRASCyGxEBILIbEQEgshsRASCyGxEBILIbEQEgshsRASCyGxEBILIbEQEgshsRASC3E79eT4a0r3793c/u9/Sq8+pnR6lpr5/CGl18+vb/v0LaXNr9SM7dvPLynd2U3Ffdx7l3rRN2N//C5vtx80ljMHE/Di2c3t79+U5Uzx9En9fYcLAuXQV6y3cyVBU9h7SiLu7i4L1Nv9+nPHJ6knfcXaUv/zt/ycZYs9WvBEtAbq0YPLRwnbZysFHenfvI6cyO81yPBEGK2B8oJUK2Fb0F+s7WStSbUsX09EpiVQXhCO+pYBo79Yk/q9kgFWG+dkWa1pjbFAzWliFoDStGJ4ibAFzBzrNQLr6FPUmtaYuU3Mew1QBgxGrDWDWhZ4I0+mpWRMZbZlau011rBqzXZLuCMvb/TyxJmIlqZkr3080eRqALU1w4n1lpiXZXNKxRiviXlNcNP3oGAIJ9ZbZt6o1DrrGgf75fJi2R84uw5hT8K0zrRWImrd28OaWKkceNkPNa0MK7Z1pl1ymJopSVypvhqsWJNa+wHjmba1aY0ZTxsrzK5D+POx3pIbZtmSpjVm2Ki8BgmXAYMX68201lhylm2TrZmDK7HeaUpwdh0ScwWhNtPmI6elTav0eVMnZ+Damul7BaGGLb3aUl9yntbDvscLEji7DokRm5dfKZN6lIC5nwfPrkPiLiYGLUGXgKaViRMbMOJMEhjcOLHeTBtBcGBj7ysIXIprf3esWG+mJQmaXYfE3wlzGDPuXGOFEhQvdo1ysIkPZrzY6GUZOLsOWeemuMiluVLDXEds5OgT3LQy64g1qScBP9gCuEIZMHb0PwgMuvEYQmIhJBZCYiEkFkJiISQWQmIhJBZCYiEkFkJiISQWQmIhJBZCYiEkFkJiISQWQmIhJBZCYiEkFkJiISQWQmIhJBZCYiEkFkJiISQWQmIhJBZCYiEkFkJiISQWQmIhJBZCYiEuAC77yTB1S+AfAAAAAElFTkSuQmCC'
          } else if (this.client == 'FjollaNila') {
            xharraIcon = 'data:image/png;base64,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'
          } else if (this.client == 'ValdrinSahiti') {
            xharraIcon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFYAAABuCAYAAAC9f+Q3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAU0SURBVHgB7Zw/aFNRFMZvxa00YwfbxckGOje7cVc3QXARXCwFx4qjWDdBOgkundwsuLbdW1ch3Vysg2NC58pHcsjp9eXl3Zd73jn2nR+U1jQJ+Mv3zj33z+vS1b2HV8HJzq3giOBihXCxQrhYIVysEC5WCBcrhIsVwsUK4WKFcLFCuFghXKwQLlYIFyuEixXCxQrhYoVwsUK4WCGaF7v9JIS9nRC2NkNW8L7nhyEcvA0WuB2a5vH9ENZWQ+gsh3D2I2RjeDn+jvc2QPOJHU0EbNwNWSGh5z+DBZoXO5j8xyFiZTlkg8SeZrwKFqB5sRd/pj/3MtbZzuRDam1iudg7Gethd1Jaztqa2AFLVDdTnaWyYkQq0E1srpaLBsKBjTIAdLqCEWuNcgxglPzvbU4s4Kldz1BnKfmtTizgAnL0s0gsPiz+gSmjI5ZmSWBRsXg9yomRNovQEcslLFoKqAwYmRgQ/38pILGe2DDtCsCinQEl3lAPC/S6Ai637kQBHwgSbyytQG+hO8cARh+IsfoK9MTmmNrSB2Iwsc0vdBO856wiFpc9VrD4QvaD3vg7ygoeN9TH2hA7a5ULI36/NxYIcRCIEkKvpY5gf3f6GqQXz8EVcfBNTbYNsZREegzbN6+fT1es3n0ef4+7ieNP48efvRk/tzuZLEA4flZMsZ7YuC7StBSbgvjCzy/3ZrdR8YoWpNNzj0+DNjYSC2hqCqkAKSxLm8EVLY7uuYJ4ACOpSN68S9jgihZHVyyX0u9NR/xOhZkYPgg+kBnDTmI56BLKzgfQNNhoGQA2xSKxONEyS67BrZgYm2IBtVM4jhQLNrYjW4Su2Ljl4n0qgZ42Fmx84AJ67RYYRiKpd4U4COW7uPg3vpDS7mRFq+iDMMKS+p8uQRopiRC99XT6O5pFYUqL77wk4LmYCOx/MdkZ6Is9/HB92bD/YraojUmvS4svBOTiyxD6B4/jOll2iAOXP9XlIzZthWyefAPoiy2a2pZBv9/9eD3dkFrWojWMPbHzdm35wIXXPno1Ta8hufZKQVliV5b/XQqE4G22CkZyc569rYG9xJbt2pbtcaFN42Xh/U7QRF8sPyRHrJfsKICiPS68B+ou0e/lv4EkARu3I1UdwOatEaAc8GkuLUMqYENs1TpbZcbF+1kkVim1NsQOK5SCtdVqe1jxInm/FzSwIfa8QmJTlgr55AHrCwrYLAVFnUHKUiHfTOwsq5QDG2KLamZ8iCNlqTClNxbCTlcQy41l0PZ4laXC0WX6SZvM2Ln7Ox7AuIw6p7YlbntKwI7YslUumvun7BjwZCtMb+2ILZraxlsxKXtcw+g4UsPYEVt0mZPQbo1dWeVtG7uJBTSAQfDw0vQeV4xtsb1NszdvzMOW2KKWq059jRk2n3Q7YkFRamlKmppY3gn8bn4X15bYosGp7l/O4AfrWp/YWQKqzrg4vMUatV3srMu9zsDFE/vLS0Hx43Xu4+KJvWi72FmXbJ3E8sFLoVWz1xUUyU1tteKVsUHbxYL4sq2TNl4GlE4l2hMbp6tOfeQrY0r32dpPbB0x/A+lHZ4EDW5eKUAZoBqL91I69W2/FKTWR14GFM/M2k9sauL4drfizR/2xPKNwNSBC2WAEvv1RPUIvT2xgJKWKoaf1VI+Om9TbJ2kIa1UBpTTCnRvR5oFjghB1FHC7fGQSjIN3Oihf9fMDcVmKbgBuFghXKwQLlYIFyuEixXCxQrhYoVwsUK4WCFcrBAuVggXK4SLFcLFCuFihXCxQrhYIVysEH8ByP7sod3WFwQAAAAASUVORK5CYII='
          } else if (this.client == 'MinnaFashion') {
            xharraIcon = 'data:image/png;base64,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'
          } else if (this.client == 'Development') {
            xharraIcon = 'data:image/png;base64,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'
          }
          const swisMade = 'data:image/png;base64,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'
          // Generate PDF with the table content
          const pdfDocument = this.generateInvoice(tableContent, tableContent2, xharraIcon, swisMade, 800);

          // Save the PDF
          pdfDocument.save(`Invoice-${moment().format('DD/MM/YYYY - hh:mm:s')}.pdf`);
        })
        .catch((error) => {
          console.error('Error downloading the data:', error);
          // this.changeLoadingtoTrue(false);
        });
    },
    generateInvoiceTableContent(invoice) {
      // Define table headers
      const headers = [`${this.$t('ProductName')}`, `${this.$t('Price')}`, `${this.$t('Discount')}`, `${this.$t('PriceWithDiscount')}`, `${this.$t('PaidPrice')}`, `${this.$t('RemainingAmount')}`, `${this.$t('RemainingPrice')}`];
      const array = invoice.invoiceOrderItemsResponseDtos
      const array1 = invoice
      const array2 = [array1]

      // Map probe dates to table body
      const body = array.map((value) => {
        const discountedPrice = (value.price - value.discount).toFixed(2);
        const remainingBill = (value.price - value.discount - value.paidAmount).toFixed(2);
        const remainingPrice = (discountedPrice - value.paidAmount).toFixed(2);
        this.emailOfClient = invoice.invoiceHeaderClientDetailsResponseDto.email
        this.phoneOfClient = invoice.invoiceHeaderClientDetailsResponseDto.telephoneNumber
        this.addressOfClient = {
          street: invoice.invoiceHeaderClientDetailsResponseDto.addressDto ? invoice.invoiceHeaderClientDetailsResponseDto.addressDto.street : 'Not Found',
          city: invoice.invoiceHeaderClientDetailsResponseDto.addressDto ? invoice.invoiceHeaderClientDetailsResponseDto.addressDto.city : 'Not Found',
        }
        this.nameOfClient = invoice.invoiceHeaderClientDetailsResponseDto.clientName

        return [
          value.articleName,
          value.price.toFixed(2),
          value.discount.toFixed(2),
          discountedPrice,
          value.paidAmount.toFixed(2),
          remainingBill,
          remainingPrice,
        ]
      });
      const headers1 = [
        `${this.$t('PromoCode')}`,
        `${this.$t('TotalPaid')}`,
        `${this.$t('TotalPrice')}`,
        `${this.$t('VAT 18%')}`,
        `${this.$t('RemainingPrice')}`,
      ];

      const body1 = array2.map((value) => {
        const vat = (value.totalPrice * 0.18).toFixed(2);
        const remainingPrice = (value.totalPrice - value.totalPaidAmount).toFixed(2); // Calculate remaining price
        return [
          `${this.client} - #5930FSG`,
          value.totalPaidAmount.toFixed(2),
          value.totalPrice.toFixed(2),
          vat,
          remainingPrice,
        ];
      });

      console.log('body1', body1);
      return {
        headers,
        body,
        headers1,
        body1,
      };
    },
    generateInvoice(tableContent, tableContent2, xharraIcon, swisMade, customWidth) {
      const { headers, body } = tableContent;
      const { headers1, body1 } = tableContent2;



      // eslint-disable-next-line new-cap
      const doc = new jsPDF({
        orientation: 'landscape', // Set the orientation to landscape if you want a wider document
        unit: 'pt', // Use points as the unit of measurement
        format: [750, 900],
      });

      // Set custom width after creating the doc instance
      doc.setProperties({
        format: [customWidth, doc.internal.pageSize.getHeight()], // Set custom width
      });

      const iconWidth = 90;
      const iconHeight = 120;
      const iconY = 0;
      const iconX = 40;
      doc.addImage(xharraIcon, 'PNG', iconX, iconY, iconWidth, iconHeight);

      let url;
      let address;
      if (this.client == 'NotaBrillant') {
        url = 'www.nota-brillant.com'
        address = 'Prishtinë-Ferizaj highway 4km, Prishtinë, Kosova'
      } else {
        url = 'http://localhost:8080/';
        address = 'Spim Fashion Group';
      }
      const urlX = 40;
      const pageHeight = doc.internal.pageSize.getHeight();
      const urlY = pageHeight - 40;
      doc.setFontSize(15);
      doc.setTextColor(11, 19, 84);
      doc.text(url, urlX, urlY, { align: 'left' });

      const addressX = 40;
      const addressY = pageHeight - 20;
      doc.setFontSize(15);
      doc.setTextColor(11, 19, 84);
      doc.text(address, addressX, addressY, { align: 'left' });


      const staticContent = () => {
      };

      // Add the title
      const title = this.$t('Invoice');
      const titleY = doc.internal.pageSize.getHeight() - 670;
      const titleX = doc.internal.pageSize.getWidth() - 120;
      doc.setFontSize(45);
      doc.setFont('Arial', 'bold');
      doc.setTextColor(11, 19, 84);
      doc.text(title, titleX, titleY, { align: 'center' });

      doc.setFont('Arial', 'normal');
      // Add the author
      const authorX = 150;
      const authorY = 76;
      doc.setFontSize(22);
      doc.setTextColor(11, 19, 84);
      doc.text(`${this.$t('Spim Invoice')}`, authorX, authorY);

      const author2X = 150;
      const author2Y = 100;
      doc.setFontSize(16);
      doc.setTextColor(11, 19, 84);
      doc.text(`${this.$t('Spim Dega në Kosovë')}`, author2X, author2Y);

      const author3X = 40;
      const author3Y = 170;
      doc.setFontSize(15);
      doc.setFont('Arial', 'bold');
      doc.setTextColor(11, 19, 84);
      doc.text(`${this.$t('From')}:`, author3X, author3Y);

      doc.setFont('Arial', 'normal');

      const author4X = 92;
      const author4Y = 170;
      doc.setFontSize(15);
      doc.setTextColor(11, 19, 84);
      doc.text(`${this.client}`, author4X, author4Y);


      const author6X = 410;
      const author6Y = 170;
      doc.setFontSize(15);
      doc.setFont('Arial', 'bold');
      doc.setTextColor(11, 19, 84);
      doc.text(`${this.$t('To')}:`, author6X, author6Y);

      doc.setFont('Arial', 'normal');

      const author7X = 440;
      const author7Y = 170;
      doc.setFontSize(15);
      doc.setTextColor(11, 19, 84);
      doc.text(`${this.nameOfClient}`, author7X, author7Y);

      const author8X = 440;
      const author8Y = 190;
      doc.setFontSize(15);
      doc.setTextColor(11, 19, 84);
      doc.text(`${this.addressOfClient.city},${this.addressOfClient.street}`, author8X, author8Y);

      const author9X = 440;
      const author9Y = 210;
      doc.setFontSize(15);
      doc.setTextColor(11, 19, 84);
      doc.text(`${this.emailOfClient}`, author9X, author9Y);

      const author10X = 440;
      const author10Y = 230;
      doc.setFontSize(15);
      doc.setTextColor(11, 19, 84);
      doc.text(`${this.phoneOfClient}`, author10X, author10Y);

      const author11X = 745;
      const autho11Y = 170;
      doc.setFontSize(15);
      doc.setFont('Arial', 'bold');
      doc.setTextColor(11, 19, 84);
      doc.text(`${this.$t('Date')}:`, author11X, autho11Y);

      doc.setFont('Arial', 'normal');

      const author12X = 790;
      const author12Y = 170;
      doc.setFontSize(15);
      doc.setTextColor(11, 19, 84);
      doc.text(`${moment().format('DD-MM-YYYY')}`, author12X, author12Y);

      const author13X = 680;
      const autho13Y = 190;
      doc.setFontSize(15);
      doc.setFont('Arial', 'bold');
      doc.setTextColor(11, 19, 84);
      doc.text(`${this.$t('OrderNumber')}:`, author13X, autho13Y);

      doc.setFont('Arial', 'normal');

      const author14X = 790;
      const author14Y = 190;
      doc.setFontSize(15);
      doc.setTextColor(11, 19, 84);
      doc.text(`${this.orderNumberClient}`, author14X, author14Y);



      // Add the table
      const tableOptions = {
        startY: authorY + 190, // Adjust the vertical position of the table
        time: moment().format('DD-MM-YYYY'),
        head: [headers],
        body,
        headStyles: {
          fillColor: [234, 236, 240], // Set the background color for the header
          textColor: [11, 19, 84], // Set the text color for the header
          halign: 'center',
        },
        bodyStyles: {
          textColor: [26, 26, 26], // Set the text color for the body
          lineWidth: 0.1, // Set the width of the border lines
          lineColor: [234, 236, 240], // Set the color of the border lines
        },
        columnStyles: {
          // Adjusting individual column styles for center alignment
          0: { columnWidth: doc.internal.pageSize.getWidth() / 7.7, halign: 'center', fillColor: [255, 255, 255] },
          1: { columnWidth: doc.internal.pageSize.getWidth() / 7.7, halign: 'center', fillColor: [255, 255, 255] },
          2: { columnWidth: doc.internal.pageSize.getWidth() / 7.7, halign: 'center', fillColor: [255, 255, 255] },
          3: { columnWidth: doc.internal.pageSize.getWidth() / 7.7, halign: 'center', fillColor: [255, 255, 255] },
          4: { columnWidth: doc.internal.pageSize.getWidth() / 7.7, halign: 'center', fillColor: [255, 255, 255] },
          5: { columnWidth: doc.internal.pageSize.getWidth() / 7.7, halign: 'center', fillColor: [255, 255, 255] },
          6: { columnWidth: doc.internal.pageSize.getWidth() / 7.7, halign: 'center', fillColor: [255, 255, 255] },
        },
      };

      const tableOptions2 = {
        startY: authorY + 400, // Adjust the vertical position of the table
        time: moment().format('DD-MM-YYYY'),
        head: [headers1],
        body: body1,
        headStyles: {
          fillColor: [234, 236, 240], // Set the background color for the header
          textColor: [11, 19, 84], // Set the text color for the header
          halign: 'center',
        },
        bodyStyles: {
          textColor: [26, 26, 26], // Set the text color for the body
          lineWidth: 0.1, // Set the width of the border lines
          lineColor: [234, 236, 240], // Set the color of the border lines
        },
        columnStyles: {
          // Adjusting individual column styles for center alignment
          1: { columnWidth: doc.internal.pageSize.getWidth() / 5.7, halign: 'center', fillColor: [255, 255, 255] },
          2: { columnWidth: doc.internal.pageSize.getWidth() / 5.7, halign: 'center', fillColor: [255, 255, 255] },
          0: { columnWidth: doc.internal.pageSize.getWidth() / 5.7, halign: 'center', fillColor: [255, 255, 255] },
          3: { columnWidth: doc.internal.pageSize.getWidth() / 5.7, halign: 'center', fillColor: [255, 255, 255] },
          4: { columnWidth: doc.internal.pageSize.getWidth() / 5.7, halign: 'center', fillColor: [255, 255, 255] },
        },
      };


      doc.autoTable(tableOptions);
      doc.autoTable(tableOptions2);

      staticContent();

      return doc;
    },
    showArticleNumber() {
      this.toggleSearch = 'ArticleNumber'
    },
    showCode() {
      this.toggleSearch = 'Code'
    },
    matProps(value) {
      this.articleNumber = value.articleNumber
      this.$emit('sendArticle', value)
      this.classNameCh = value.articleNumber
      this.totalStockGroupedByLocation({ articleNumber: value.articleNumber })
    },
    resetMaterialss() {
      this.ordersArticles = []
      this.$emit('resetAllMateriales')
    },
    orderTypes() {
      this.loadOrderTypes()
      this.accountDetails({
        isActive: true,
      })
      this.usersByMultipleRoles({
        status: true,
        object: ['SalesPerson', 'OnlineSales'],
      })
    },
    inputChanged(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') { return; }
      // this.getArticleNameLike = [];

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByOn(this.getArticleNameLike[this.arrowCounter])
        this.removeLists()
        this.arrowCounter = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    onArrowDown(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.getArticleNameLike.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },
    onArrowUp(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling()
      }
    },
    fixScrolling() {
      const liH = this.$refs.options[this.arrowCounter].clientHeight;
      console.log(liH)
      if (this.arrowCounter <= 16) {
        this.$refs.scrollContainer.scrollTop = 34 * this.arrowCounter;
      } else {
        this.$refs.scrollContainer.scrollTop = 58 * this.arrowCounter;
      }
    },
    async searchByOn(value) {
      this.searchArticle = value.articleNumber;
      this.noSearch = false;
      await this.sellableProducts({
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        articleNumber: this.searchArticle,
      })
    },
    removeLists() {
      this.noSearch = false;
      this.resetFilteredMVBySearch();
    },
  },
}
</script>

<style scoped lang="scss">
.prev-itemi {
  padding-right: 340px !important;
}
.sellProducts {
  width: 55%;
}
.next-itemi {
  padding-left: 340px !important;
}
.number {
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 50%;
  background-color: red;
  color: white;
  position: relative;
  bottom: 50%;
  left: 75%;
  border:1px solid white;
}

.team_table td {
  padding: 12px 9px !important;
}

.team_table th {
  // text-align: center;
}

.editButton {
  height: 30px;
}
.active2 {
  font-weight: bold;
  color: $base-color;
}
.active2{
  color: $base-color;
  font-weight: bold;
}
.hover-row:hover {
    background-color: rgba(255, 39, 79, 0.1);
}
.mats-listing__wrapper {
  .mats-listing{
    margin-top: 0
  }
}
  .button {
    margin-bottom: 15px!important;
  }
  .mat {
    display: flex;
    justify-content: space-between;
    align-content: center;
    &.active {
      background-color: #e8e8e8;
    }
    div {
      display: flex;
      justify-content: space-between;
      align-content: center;
    }
    span {
      margin-left: 10px;
      svg {
        font-size: 15px;
      }
    }
  }
  .team_table {
  font-size: 12px;
  border-radius: 8px 8px 8px 8px !important;
}



table:hover {
  cursor: pointer;
}
.dropdrop::-webkit-scrollbar {
display: none;

}
.dropdrop {
display: inline-block;
overflow: auto;
position: absolute;
background: white;
width: 227px;
box-shadow: none;
}

input[name="search-box"] {
  display: block;
  max-width: 500px;
  width: 95%;
  padding: 0.5rem 1rem;
  padding-left: 25px;
}
.search-item {
  padding: 5px;
  max-width: 500px;
  width: 100%;
  font-weight: 400;
  color: #82868c;
  font-size: 1rem;
  border-bottom: 1px solid #e8e8e8;
}
.search-item:last-child {
  border-bottom: none;
}
.search-item:hover {
  background: #82868c;
  color: white;
}
.search-item hr {
  color: lightgray;
  border-top: none;
  margin: -1.3rem 0 0.5rem 0;
}
.is-active {
  background-color: #dedede;
}
@media screen and (max-width: 1200px) {
  .sellProducts {
    width: 100%;
  }
}
</style>
